export default __webpack_public_path__ + "static/media/c-shape.aea7adef.png";